import React, { useMemo } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsInfoCircle } from 'react-icons/bs';

import { renderHeaderWithHover } from '@components/Table/Columns';
import { BootstrapTable } from '@components/Table/Table';
import { planDetailsApi } from '@reducers/plan';

const renderDocumentWithHover = ({ value }) => {
  if (!value) {
    return null;
  }
  const { name, description } = value;
  if (!description) {
    return name;
  }
  return (
    <OverlayTrigger
      placement="right"
      overlay={
        <Tooltip id={`tooltip-${name}`} style={{ position: 'fixed' }}>
          {description}
        </Tooltip>
      }
    >
      <span>
        {name}{' '}
        <span className="textGreen">
          <BsInfoCircle size={17} />
        </span>
      </span>
    </OverlayTrigger>
  );
};

export const PlanRequirementsTable = ({ data }) => {
  const query = planDetailsApi.useGetFieldDescriptionQuery();
  const fieldDescriptions = query.data || {};
  const columns = useMemo(
    () => [
      {
        Header: () =>
          renderHeaderWithHover(
            'User details (data Entry)',
            'user_details',
            fieldDescriptions
          ),
        Cell: renderDocumentWithHover,
        accessor: 'userDetail',
        className: 'col-md-6',
      },
      {
        Header: () =>
          renderHeaderWithHover(
            'Documents (Upload)',
            'documents',
            fieldDescriptions
          ),
        Cell: renderDocumentWithHover,
        accessor: 'document',
        className: 'col-md-6',
      },
    ],
    []
  );
  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({
        responsive: true,
        bordered: true,
        style: { marginBottom: '0px' },
        className: 'normalFontSize',
      })}
      tableHeader="Required information"
    />
  );
};
